export const LargeFormatPriceType = {
  PriceA: 'PriceA',
  PriceB: 'PriceB'
};

export const LargeFormatPriceTypeDescription = {
  [LargeFormatPriceType.PriceA]: 'Price A',
  [LargeFormatPriceType.PriceB]: 'Price B'
};
